import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function getDefaultItems(jenisPaket: string) {
  const response = await http.getData(`/permintaan-obat-paket/default-items/${jenisPaket}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function create(data) {
  const response = await http.postData("/permintaan-obat-paket", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id: number, data) {
  const response = await http.putData(`/permintaan-obat-paket/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(registerId: string | number, jenisPaket: string) {
  const response = await http.getData(`/register/${registerId}/permintaan-obat-paket/${jenisPaket}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/permintaan-obat-paket/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signDpjp(id: number, data) {
  const response = await http.putData(`/permintaan-obat-paket/${id}/sign-dpjp`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function kirim(id: number) {
  const response = await http.putData(`/permintaan-obat-paket/${id}/kirim`, {}).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function catatKpra(id: number, data) {
  const response = await http.putData(`/permintaan-obat-paket/${id}/kpra`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function verifikasiKpra(id: number, data) {
  const response = await http.putData(`/permintaan-obat-paket/${id}/verifikasi-kpra`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function listAntimikroba(params) {
  const response = await http.getDataParam("/permintaan-antimikroba-reserve", { params }).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/permintaan-obat-paket/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/permintaan-obat-paket/${id}/pdf`, "_blank");
}

export default {
  getDefaultItems,
  create,
  update,
  getByRegister,
  find,
  signDpjp,
  kirim,
  catatKpra,
  verifikasiKpra,
  listAntimikroba,
  destroy,
  print
};
